import dayjs from "dayjs";
import { useFormikContext } from "formik";
import { FC, useEffect } from "react";

import DatepickerFormikMUI from "web/Layout/Datepicker/DatepickerCafe/datepickerFormik";
import __ from "web/Layout/Translations";

import { dayMilliseconds } from "web/constants/date";

import { DateFields, names } from "../domesticTourismFormFields";
import classes from "./dateFields.scss";

interface IDomesticTourismFormDateFieldsProps {
  fields: DateFields;
}

const DomesticTourismFormDateFields: FC<
  IDomesticTourismFormDateFieldsProps
> = ({ fields }) => {
  const { values, setFieldValue } = useFormikContext<Record<string, string>>();

  const minDate =
    values[names.dateFrom] && +values[names.dateFrom]
      ? +values[names.dateFrom] + dayMilliseconds
      : Date.now() + dayMilliseconds;

  useEffect(() => {
    if (
      +values[names.dateFrom] > +values[names.dateTo] &&
      +values[names.dateTo]
    ) {
      setFieldValue(names.dateTo, null);
    }
  }, [JSON.stringify(values), setFieldValue]);

  return (
    <div className={classes.root}>
      {fields.map(({ name, label, placeholder }, index) => {
        const [minDateValue, maxDateValue] =
          name === names.dateFrom
            ? [dayjs().add(1, "day"), null]
            : [minDate, null];

        const id = `date-field-${name}-${index}`;

        return (
          <div className={classes.wrapper} key={name}>
            <label className={classes.badge} htmlFor={id}>
              {__(label)}
            </label>
            <div>
              <DatepickerFormikMUI
                id={id}
                name={name}
                placeholder={__(placeholder)}
                minDate={
                  name === "tourism_date_to"
                    ? (minDateValue as number) - dayMilliseconds
                    : minDateValue
                }
                maxDate={maxDateValue}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default DomesticTourismFormDateFields;
